import React from "react";
import { ILinkComponentProps } from "../../interfaces";
import { IoArrowForwardSharp } from "react-icons/io5";
import Link from "next/link";

interface IComponentProps extends Omit<ILinkComponentProps, "text"> {
  text: string;
}

const BackwardsArrowLink: React.FC<IComponentProps> = ({
  href,
  text,
  label,
  target,
}) => {
  return (
    <Link
      href={href}
      className="group mb-2 inline-flex items-center font-semibold leading-tight text-blue-300"
      aria-label={label}
      target={target}
    >
      <IoArrowForwardSharp className="mr-1 h-4 w-4 rotate-180 transition-transform group-hover:-translate-x-2" />
      {text}
    </Link>
  );
};

export default BackwardsArrowLink;
